import { forwardRef, type ReactElement } from "react";
import type { IconProps, IconVariant } from "./types";

interface IconBaseProps extends IconProps {
	variants: Map<IconVariant, ReactElement>;
}

const IconBase = forwardRef<SVGSVGElement, IconBaseProps>((props, ref) => {
	const {
		alt,
		color = "currentColor",
		size = "1em",
		variant = "line",
		mirrored = false,
		children,
		variants,
		...restProps
	} = props;

	return (
		<svg
			ref={ref}
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 24 24"
			transform={mirrored ? "scale(-1, 1)" : undefined}
			{...restProps}
		>
			{!!alt && <title>{alt}</title>}
			{children}
			{variants.get(variant)}
		</svg>
	);
});

export default IconBase;
